// Card title helpers (Longform, D-089): an EPISODE card is an ordinary card that
// carries episodeNumber / episodeTitle. Every grid, chip and header shows the
// series name plus a compact "Ep N" tag so episodes read as one series.
export function episodeTag(rec) {
  return rec?.episodeNumber ? `Ep ${rec.episodeNumber}` : '';
}
export function cardTitle(rec, fallback = '(Riff)') {
  const base = rec?.script?.scriptName || rec?.notes || fallback;
  const tag = episodeTag(rec);
  return tag ? `${base} · ${tag}` : base;
}
